import { render, staticRenderFns } from "./UserDeliveryAddressList.vue?vue&type=template&id=644d8a46"
import script from "./UserDeliveryAddressList.vue?vue&type=script&lang=js"
export * from "./UserDeliveryAddressList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports